const Header = () => (
  <header className="text-center p-2 bg-pallete-400 md:p-5">
    <h1 className="text-4xl font-extrabold text-gray-300 uppercase">
      Player Ratings
    </h1>
  </header>
);

export default Header;
